const initialState = {
    nextStep:'APP_INIT',
    executionStep:'',
    tokenId: '',
    href: '',
    search: '',
    user: null,
    sessionExpired:false,
    outsideNetworkLink:false,
    appLoadError:false,
    breadcrumb:''
}


export default function application(state = initialState, action) {
    switch (action.type) {
        case "APP_INIT":
        return {
                ...state,
                href: action.payload.href,
                search: action.payload.search,
                tokenId: action.payload.tokenIdFromURL,
                nextStep:'AUTH_INIT'
        }

        case "AUTH_INIT_PENDING":
            return {...state, executionStep:'AUTH_INIT'};
        case "AUTH_INIT_FULFILLED":
            return {
                ...state,
                nextStep:'USER_INIT',
                initialized: true
            }
        case "AUTH_INIT_REJECTED":
            return {
                ...state,
                nextStep:'USER_LOGIN',
                initialized: true
            }
        case "USER_INIT_PENDING":
            return {...state, 
                executionStep:'USER_INIT'
            };
        case "USER_INIT_FULFILLED":
            return {
                ...state,
                user: action.payload.data,
                nextStep:action.payload.data.termAndCondtionAccepted === true?'APP_VIEW':'TERMS_CONDITION'
            }
        case "USER_INIT_REJECTED":
            return {
                ...state,
                nextStep:'APP_VIEW_ERROR',
            }
        case "API_SESSION_EXPIRED":
        return {
            ...state,
            sessionExpired: true,
            nextStep:'USER_LOGIN',
        }
        case "OUTSIDE_LINK_FOUND":
	        return {
	            ...state,
	            outsideNetworkLink: true,
	            nextStep:'USER_LOGIN',
	        }
        case "APP_LOAD_ERROR":
            return {
                ...state,
                appLoadError: true,
                nextStep:'USER_LOGIN',
            }
        case "VIEW_CHANGED":
            return {
                ...state,
                breadcrumb: action.payload
            }
        default:
            return state
    }
}